export default __webpack_public_path__ + "static/media/6d.4e518308.png";